import React from 'react';
import IconButton from './IconButton';

const DeleteButton = ({
  icon = 'trash',
  inProgress,
  disabled,
  messageId = 'actions.delete',
  minimumDataEntryMet,
  onClick,
  secondary,
}) => (
  <IconButton
    className="aridhia-delete-button"
    disabled={inProgress || !minimumDataEntryMet || disabled}
    icon
    iconName={icon}
    loading={inProgress}
    messageId={messageId}
    onClick={onClick}
    negative={!secondary}
    secondary={secondary}
  />
);

export default DeleteButton;
